import { SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { isAbsoluteUrl } from '@msdyn365-commerce/core';
import { IExtExternalScriptProps, IExtExternalScriptConfig } from './ext-external-script.props.autogenerated';
import { getPublicAssetPath } from '../../shared/functions/msdyn-helpers';

const getAsyncOrDeferAttribute = (config: IExtExternalScriptConfig): string => {
    // Async will always take precendence over defer, so no point in returning defer if async is active
    if (config.async) {
        return 'async';
    }
    if (config.defer) {
        return 'defer';
    }
    return '';
};

/**
 *
 * DefaultExternalScript component
 * @extends {React.PureComponent<IDefaultExternalScriptProps<{}>>}
 */
class DefaultExternalScript extends React.PureComponent<IExtExternalScriptProps<{}>> {
    constructor(props: IExtExternalScriptProps<{}>) {
        super(props);
    }
    public render(): JSX.Element | null {
        const { config, context } = this.props;

        let source = config.scriptSource;
        if (isRelativeUrl(source) && context) {
            // If the source is a relative URL prepend the relative base url to the resolved source url for the actual source
            source = getPublicAssetPath(context, source);
        } else if (source === '' || !isAbsoluteUrl(source)) {
            this.props.telemetry.error(
                'Invalid external script - not a url. The external source is not an external or relative url, please use default-inline-script if you wish to load inline scripts',
                this.props.telemetry
            );
            return null;
        }

        let scriptAttr = '';
        config.scriptAttributes?.forEach(attr => {
            scriptAttr += `${attr.attributeKey}='${attr.attributeValue}' `;
        });

        const scriptHtml = `<script src="${source}" ${getAsyncOrDeferAttribute(config)} ${scriptAttr}></script>`;
        return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: scriptHtml } });
    }
}

export default DefaultExternalScript;

const isRelativeUrl = (source: string): boolean => {
    return /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/).*(\.js){1}$/.test(source);
};
